// extracted by mini-css-extract-plugin
export default {"root":"Fact_root__wvZjZ","image":"Fact_image__aA2tp","text":"Fact_text__2uHji"};